<ion-grid>
  <ion-row *ngIf="loading">
    <ion-col class="c3-flex ion-justify-content-center">
      <ion-spinner color="secondary"></ion-spinner>
    </ion-col>
  </ion-row>

  <ion-row class="ion-justify-content-center">
    <ion-col size="auto" class="c3-flex ion-align-items-center">
      <h1 class="c3-monospace app-text-slashed-zero">
        <span>{{ activationCode }}</span>
      </h1>
    </ion-col>
    <ion-col size="auto" class="c3-flex ion-align-items-center">
      <c3-copy
        *ngIf="activationCode"
        c3Tooltip="Copia nella clipboard"
        [copyText]="activationCode"
      ></c3-copy>
    </ion-col>
  </ion-row>

  <ng-container *ngIf="activationCodeExpirationDate && !isExpired">
    <ion-row>
      <ion-col>
        <p *ngIf="activationCodeExpirationDate && !isExpired">
          Il codice <strong>scadrà </strong> <strong>{{ remainingTime }}</strong> alle ore
          {{ activationCodeExpirationDate | date: "HH:mm 'del' dd/MM/YYYY" }}
        </p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <ion-progress-bar
          type="determinate"
          [value]="remainingPercentage"
          [color]="remainingPercentage > 0.2 ? 'primary' : 'danger'"
        >
        </ion-progress-bar>
      </ion-col>
    </ion-row>
  </ng-container>

  <ion-row *ngIf="activationCodeExpirationDate && isExpired">
    <ion-col class="ion-text-center">
      <ion-text color="danger">
        <p>Il codice è scaduto</p>
      </ion-text>
    </ion-col>
  </ion-row>
</ion-grid>
